import React from 'react'

function Female() {
  return (
    <div>
        <h1>Female</h1>
    </div>
  )
}

export default Female